import React from "react";
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {
  render() {
    const searchData = this.props.searchData;
    const searchDate = this.props.searchDate;
    const reportData = this.props.reportData;
    const totalAmount = this.props.total;

    return (
      <div style={{ backgroundColor: 'white', minHeight: '100vh', padding: '4px' }}>
        <h2><center><u>Accounts Payable with Aging Report</u></center></h2>
        <div>&nbsp;</div>
        <h2><center>{searchData.groupName} - {searchData.factoryName}</center></h2>
        <div>&nbsp;</div>
        <h3><center>From: {moment(searchData.startDate).format('MM/DD/YYYY')} To: {moment(searchData.endDate).format('MM/DD/YYYY')}</center></h3>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer style={{ marginLeft: '5px' }}>
              <Table aria-label="caption table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>SUPPLIER</TableCell>
                    <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>INVOICE No.</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>INVOICE DATE</TableCell>
                    <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>AMOUNT</TableCell>
                    <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>DAYS OUTSTANDING</TableCell>
                    <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>AGING BUCKET</TableCell>
                    <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>0-30 Days</TableCell>
                    <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>31-60 Days</TableCell>
                    <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>61-90 Days</TableCell>
                    <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>90+ Days</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reportData.map((data, index) => {
                    const days = data.daysAboveDueDate;
                    let agingBucket = '';
                    let bucket0_30 = '-';
                    let bucket31_60 = '-';
                    let bucket61_90 = '-';
                    let bucket90Plus = '-';

                    if (days >= 0 && days <= 30) {
                      agingBucket = '0-30 Days';
                      bucket0_30 = data.amount.toFixed(2);
                    } else if (days >= 31 && days <= 60) {
                      agingBucket = '31-60 Days';
                      bucket31_60 = data.amount.toFixed(2);
                    } else if (days >= 61 && days <= 90) {
                      agingBucket = '61-90 Days';
                      bucket61_90 = data.amount.toFixed(2);
                    } else if (days > 90) {
                      agingBucket = '90+ Days';
                      bucket90Plus = data.amount.toFixed(2);
                    }

                    return (
                      <TableRow key={index}>
                        <TableCell align={'left'} style={{ borderBottom: "none", border: "1px solid black" }}>
                          {data.supplierName}
                        </TableCell>
                        <TableCell align={'left'} style={{ borderBottom: "none", border: "1px solid black" }}>
                          {data.invoice}
                        </TableCell>
                        <TableCell align={'center'} style={{ borderBottom: "none", border: "1px solid black" }}>
                          {moment(data.invoiceDate).format('M/D/YYYY')}
                        </TableCell>
                        <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                          {data.amount.toFixed(2)}
                        </TableCell>
                        <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                          {data.daysAboveDueDate}
                        </TableCell>
                        <TableCell align={'left'} style={{ borderBottom: "none", border: "1px solid black" }}>
                          {agingBucket}
                        </TableCell>
                        <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                          {bucket0_30}
                        </TableCell>
                        <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                          {bucket31_60}
                        </TableCell>
                        <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                          {bucket61_90}
                        </TableCell>
                        <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                          {bucket90Plus}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                <TableRow>
                  <TableCell align={'left'} colSpan={3} style={{ borderBottom: "none", border: "1px solid black" }}>
                    <b>Total</b>
                  </TableCell>
                  <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                    <b>{parseFloat(totalAmount.totalamount).toFixed(2)}</b>
                  </TableCell>
                  <TableCell align={'center'} colSpan={2} style={{ borderBottom: "none", border: "1px solid black" }}>
                  </TableCell>
                  <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                    <b>{totalAmount.bucket0_30 > 0 ? totalAmount.bucket0_30.toFixed(2) : '-'}</b>
                  </TableCell>
                  <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                    <b>{totalAmount.bucket31_60 > 0 ? totalAmount.bucket31_60.toFixed(2) : '-'}</b>
                  </TableCell>
                  <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                    <b>{totalAmount.bucket61_90 > 0 ? totalAmount.bucket61_90.toFixed(2) : '-'}</b>
                  </TableCell>
                  <TableCell align={'right'} style={{ borderBottom: "none", border: "1px solid black" }}>
                    <b>{totalAmount.bucket90Plus > 0 ? totalAmount.bucket90Plus.toFixed(2) : '-'}</b>
                  </TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}